import { Injectable } from '@angular/core';
import {
	Router, Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot,
	ActivatedRoute
} from '@angular/router';
import { forkJoin, NEVER, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { TermsOfUse } from '../models/terms-of-use.model';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { UserAuthService } from '../services/user-auth.service';

@Injectable({
	providedIn: 'root'
})
export class HasAcceptedTermsResolver implements Resolve<Observable<boolean>> {

	constructor(
		private userAuthService: UserAuthService,
		private router: Router,
		private activatedRoute: ActivatedRoute
	) {}
	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return forkJoin([
			this.userAuthService.requiresTermsAcceptance(activatedRouteSnapshot.paramMap.get('token')),
			this.userAuthService.getTermsOfUse(activatedRouteSnapshot.paramMap.get('token'))
		])
			.pipe(
				catchError(() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return of([false, null]);
				}),
				tap(([requiresTermsAcceptance, termsOfUse]) => {
					if (requiresTermsAcceptance && !!termsOfUse) {
						this.router.navigate([`${activatedRouteSnapshot.paramMap.get('token')}/my-work/terms-of-use`]);
					}
				}),
				map(([requiresTermsAcceptance, termsOfUse]) =>  requiresTermsAcceptance)
			);
	}
}
